// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__7UpPeunf","tab":"Tabs_tab__5eK5xe-J","active":"Tabs_active__V6UvNVYj"};